module.exports = __webpack_public_path__ + "img/PeepsBesideRight.6ec0ea7c.svg";